function EscalationPlan() {
    "use strict";

    this.__type = 'EscalationPlan:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.CycleInterval = '';
    this.IsActive = true;
    this.IsShared = false;
    this.Name = '';
    this.OrganizationId = -1;
    this.RetryCount = '';
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = EscalationPlan;
}